import {
  Box,
  Button,
  useDisclosure,
  Drawer,
  DrawerContent,
  DrawerBody,
  Flex,
  Text,
  Center,
  Divider,
  Heading,
  Image,
} from '@chakra-ui/react'

import { ChevronRightIcon, ChevronLeftIcon } from '@chakra-ui/icons'

import PickModel from './pickModel'
import SelectedModel from './selectedModel'
import DesignYourOwn from './designYourOwn'
import SetTheScene from './setTheScene'
import { useContext, useEffect, useState } from 'react'

import { DevTools } from '../DevTools'
import { getForceLandingPage, isLocal } from '../../utils/utils'
import ModelConfiguration from './modelConfiguration'
import PageHeader from './pageHeader'
import { AppContext } from '../../libs/context'

const buttonSx = {
  paddingInline: '0',
  borderTopWidth: '1px',
  fontWeight: 'normal',
  h: 'auto',
  bg: 'none',
  borderRadius: 'unset',
  width: '100%',
}

const buttonBoxSx = {
  paddingInline: '4',
  paddingBlockStart: '3',
  paddingBlockEnd: '2',
}

const accordionSx = {
  paddingInline: '15',
  flex: '1',
  textAlign: 'left',
  fontSize: 'lg',
}

const descriptionSx = {
  fontSize: '15px',
  marginBlock: '10px',
  whiteSpace: 'pre-wrap',
  textAlign: 'left',
  paddingInline: '15',
}

export enum PageEnum {
  DesignYourOwn = 'Design Your Own',
  PickYourModel = 'Pick Your Model',
  SetTheScene = 'Set The Scene',
  ProductConfiguration = 'Product Configuration',
}

const DesignPanel = () => {
  const [page, setPage] = useState(PageEnum.DesignYourOwn)
  const { isOpen, onOpen, onClose } = useDisclosure()

  useEffect(() => {
    const forceLanding = getForceLandingPage() as PageEnum

    if (forceLanding && Object.values(PageEnum).includes(forceLanding)) {
      setPage(forceLanding)
      onOpen()
    }

    // if (!model?.current.preview || model.current.preview === '') {
    //   setPage(PageEnum.ProductConfiguration)
    //   onOpen()
    // }
  }, [])

  return (
    <>
      <Box id="desktop-menu">
        <Box className="desktop-only">
          <Heading fontSize="26px">Welcome to the Design Room</Heading>
          <Text fontSize="15px" marginBlock="10px">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </Text>
        </Box>
        <SelectedModel id="outside-model-detail" />
        <Button
          display="inline-block"
          sx={buttonSx}
          onClick={() => {
            setPage(PageEnum.DesignYourOwn)
            onOpen()
          }}
          className="main-menu-button"
          id="design-your-own-btn"
        >
          <Flex w="100%" flexDir="row">
            <Box id="design-your-own-img-container" className="desktop-only">
              <Image src="/design-your-own.jpg" />
            </Box>

            <Box sx={buttonBoxSx}>
              <Flex w="100%">
                <Box sx={accordionSx}>Design Your Own</Box>
                <ChevronRightIcon fontSize="lg" />
              </Flex>
              <Text sx={descriptionSx} className="desktop-only">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </Text>
            </Box>
          </Flex>
        </Button>

        <Divider className="desktop-only" marginBlock="15px"></Divider>

        <Button
          display="inline-block"
          sx={buttonSx}
          onClick={() => {
            setPage(PageEnum.PickYourModel)
            onOpen()
          }}
          className="main-menu-button"
        >
          <Box sx={buttonBoxSx}>
            <Flex w="100%">
              <Box sx={accordionSx}>Pick Your Model</Box>
              <ChevronRightIcon fontSize="lg" />
            </Flex>
            <Text sx={descriptionSx} className="desktop-only">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </Text>
          </Box>
        </Button>

        <Button
          display="inline-block"
          sx={buttonSx}
          onClick={() => {
            setPage(PageEnum.SetTheScene)
            onOpen()
          }}
          className="main-menu-button"
        >
          <Box sx={buttonBoxSx}>
            <Flex w="100%">
              <Box sx={accordionSx}>Set The Scene</Box>
              <ChevronRightIcon fontSize="lg" />
            </Flex>
            <Text sx={descriptionSx} className="desktop-only">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </Text>
          </Box>
        </Button>

        {isLocal() && <DevTools />}
      </Box>

      <Drawer
        onClose={onClose}
        isOpen={isOpen}
        size="sm"
        isFullHeight={false}
        closeOnOverlayClick={false}
        trapFocus={false}
      >
        {/* <DrawerOverlay /> */}
        <DrawerContent>
          <PageHeader
            page={page}
            onOpen={onOpen}
            onClose={onClose}
            setPage={setPage}
          />

          <DrawerBody padding="0">
            {page === PageEnum.DesignYourOwn && <DesignYourOwn />}
            {page === PageEnum.PickYourModel && <PickModel setPage={setPage} />}
            {page === PageEnum.SetTheScene && <SetTheScene />}
            {page === PageEnum.ProductConfiguration && <ModelConfiguration />}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default DesignPanel
